import classNames from 'classnames';
import React from 'react';
interface OldImagesProps {
  oldImages?: Array<IImage>;
  mainImageGuid: string;
  removeImage: (item: string) => void;
}
const OldImages = ({oldImages, mainImageGuid, removeImage}: OldImagesProps) => {
  return (
    <>
      {oldImages?.map(item => (
        <div
          key={item.id}
          className="flex justify-between mx-0 my-[20px] items-center"
        >
          <div className="flex">
            <img
              className="w-[74px] h-[74px] rounded-[2px] object-cover	"
              src={item.image}
              alt={item.image}
            />
          </div>
          <div className={classNames('flex', '')}>
            <button
              className="ms-2"
              type="button"
              onClick={() => console.log()}
            >
              {mainImageGuid === item.guid ? (
                <i className="icon-flag-select text-primary"></i>
              ) : (
                <i className="icon-flag-deselect text-gray-6"></i>
              )}
            </button>
            <button
              className=" bg-error text-white mr-3 w-[32px] h-[32px] rounded-[4px] flex justify-center items-center"
              type="button"
              onClick={() => removeImage(item.guid)}
            >
              <i className="icon-trash fs-6"></i>
            </button>
          </div>
        </div>
      ))}
    </>
  );
};

export default OldImages;
